module.exports = __webpack_public_path__ + "img/selbsterfahrung_960.27c493d6.png";